import { connect } from "react-redux";
import { setQty } from "../../redux/actions";
import ActionBar from "../ActionBar";

export default connect(({ product }) => ({ qty: product.qty }), { setQty })(
  ActionBar
);
